module.exports = __webpack_public_path__ + "img/bracelet.fc7bc7bf.jpg";